// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3qL25","inputWrap":"styles_inputWrap__3vq2v","input":"styles_input__3sOnl"};